import React from 'react';

import './SideMenuSection.css';

export const SideMenuSection = ({title, links, activeSection, closed, toggleClosed, navigateTo, setContext}) => {

    const navigate = (link) => {
        if (link.screenKey === "trainingCapture") {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
                selectedTraining: null,
                newTrainingSelected: true,
            }));
            navigateTo(link.screenKey);
        } else if (link.screenKey === "changePackageView") {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
                selectedChangePackage: null,
                addChangeIdeasToPackage: false,
                captureNewPackage: true,
                addClick: false,
            }));
            navigateTo(link.screenKey);
        } else if (link.screenKey === "changePackageSearch") {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
                addClick: false,
            }));
            navigateTo(link.screenKey);
        } else if (link.screenKey === "gatesPerspectiveTable") {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
                selectedLibrary: null,
                captureNewLibrary: false,
                addFilesToLibrary: false,
                filesToUploadList: [],
            }));
            navigateTo(link.screenKey);
        } else if (link.screenKey === "facilitySelect") {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
                editMode: true,
            }));
            navigateTo(link.screenKey);
        } else {
            setContext((prevState) => ({
                ...prevState,
                activeSection: link.name,
            }));
            navigateTo(link.screenKey);
        }
    }

    const sectionLinks = links.map((link, index) => {

        const isActive = activeSection === link.name;

        return (
            <p
                className={"side-menu-item-text " + (isActive ? "side-menu-item-active" : null)}
                key={index}
                onClick={() => {
                    navigate(link)
                }}>
                {link.name}
            </p>
        );
    });

    return (
        <div
            className={"side-menu-section-container " + (closed ? "side-menu-section-closed" : "side-menu-section-open")}>
            <p className="side-menu-section-text" onClick={() => {
                toggleClosed(title)
            }}>{title}</p>
            {sectionLinks}
        </div>
    );
}
